import { render, staticRenderFns } from "./SearchEvent.vue?vue&type=template&id=21b08a06&scoped=true&lang=pug&"
import script from "./SearchEvent.vue?vue&type=script&lang=js&"
export * from "./SearchEvent.vue?vue&type=script&lang=js&"
import style0 from "./SearchEvent.vue?vue&type=style&index=0&id=21b08a06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b08a06",
  null
  
)

export default component.exports